import {GetRefundSpecialtiesParams} from 'domain/usecases';
import {makeGetRefundSpecialties} from 'main/factories/usecases';

export const getRefundSpecialties = async (params: GetRefundSpecialtiesParams) => {
	const data = await makeGetRefundSpecialties().get(params);

	if (!data) {
		return {
			content: {
				specialties: [],
				total: 0,
			},
		};
	}

	return data;
};
